Wee.fn.make('search-results', {
	init: function() {
		this.$private.initEvents();
	},

	unload: function() {
		$.events.off(false, '.searchResults');
	}
}, {

	/**
	 * Init events
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$('ref:paginationLink').off(false, 'history');

		Wee.events.on({
			'ref:searchCategory': {
				'click': function(e, el) {
					var $el = $(el),
						$searchResultsContainer = $('ref:searchResultsContainer');

					$('ref:productsCat').isActive() ?
						$searchResultsContainer.addClass('-gray') :
						$searchResultsContainer.removeClass('-gray');

					$.history.go({
						path: Wee.routes.uri().path + scope.getQuery($el[0].innerHTML.toLowerCase())
					});
				}
			}
		}, {
			namespace: 'searchResults'
		});
	},

	/**
	 * Get query string to determine what results tab to activate
	 * @param  {string} category User-selected category tab
	 * @private
	 */
	getQuery: function(category) {
		var query = '?',
			routeQuery = Wee.routes.uri().query,
			keys;

		routeQuery.category = category;

		keys = Object.keys(routeQuery);

		for (var i = 0; i < keys.length; i++) {
			query += keys[i] + '=' + routeQuery[keys[i]];

			if (i !== keys.length - 1) {
				query += '&';
			}
		}

		return query;
	}
});